var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-skeleton',{attrs:{"animation":_vm.animation,"height":_vm.height,"width":_vm.width}})
}
var staticRenderFns = []

export { render, staticRenderFns }